import React from 'react';
import Helmet from "react-helmet";
import {config} from "../../config";

const ErrorUnauthorized = () => {

    return (
        <div className="page-not-found">
            <Helmet>
                {config.preTitle}Erreur 401{config.postTitle}
                <meta name="prerender-status-code" content="401" />
            </Helmet>
            <h2>401</h2>
            <span>- Page non autorisée -</span>
            <span>Désolé mais vous n'êtes pas autorisé à afficher cette page.</span>
        </div>
    )
};

export default ErrorUnauthorized;